export const BUDGET_SLIDER_GAP_FACTOR = 0.05;

export const KEY_EVENT_KEYS = {
    ESC: 'Escape',
    TAB: 'Tab',
    SPACE: ' ',
    ARROW_UP: 'ArrowUp',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ENTER: 'Enter',
} as const;

export const MEDIA_REGEX =
    /(?:^|\s)(Offline|Online)(?:\s|$)|^(Offline media|Online media|Partner|Store media)$/i;

export const INTERVAL_WEEKLY = 'weekly';
export const INTERVAL_DAILY = 'daily';
